import React, { FunctionComponent, memo } from 'react';
import { Box } from '@material-ui/core';
import Price from '../../../../../../gqlCommon/components/presentation/Price';
import optionPriceMultiCurrencyStyles from './optionPriceMultiCurrencyStyles';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import IPrice from '../../../../../../gqlCommon/model/prices/IPrice';
import usePrice from '../../../../../../gqlCommon/hooks/prices/usePrice';
import Translation from '../../../../../../common/components/translation/Translation';
import { PriceDisplayType } from '../../../../../../../../common/enum/PriceDisplayType';

export interface IOptionPriceMultiCurrencyProps {
  prices: IPrice[];
  showOrLabel: boolean | undefined;
  classes?: {
    container: string | undefined;
    priceText: string | undefined;
  };
}

const OptionPriceMultiCurrency: FunctionComponent<IOptionPriceMultiCurrencyProps> = memo(
  ({ prices, classes, showOrLabel = false }) => {
    const styles = optionPriceMultiCurrencyStyles();
    const { primaryPrice, secondaryPrice } = usePrice(prices);

    return (
      <Box className={clsx([styles.container, classes?.container])}>
        <Price
          className={clsx([styles.accessoryPrice, classes?.priceText])}
          price={primaryPrice?.money.amount}
          data-test={'option:price:primary'}
          priceDisplayType={PriceDisplayType.PRIMARY_OPTIONS}
        />
        {showOrLabel && (
          <Typography data-test="option:price:or" className={styles.orLabel}>
            <Translation id="trans__configurator__price_display__text_between_prices" />
          </Typography>
        )}
        <Price
          className={clsx([classes?.priceText, styles.secondaryAccessoryPrice])}
          price={secondaryPrice?.money.amount}
          data-test={'option:price:secondary'}
          priceDisplayType={PriceDisplayType.SECONDARY_OPTIONS}
        />
      </Box>
    );
  },
);

export default OptionPriceMultiCurrency;
